<template>
  <div class="row" id="pakiet-pszczelego-bohatera-mp">
    <div class="col-12">
      <div class="about__box">
        <h2 class="about__headline">
          Pakiet Pszczelego Bohatera / Bohaterki
        </h2>
        <div class="about__content">
          <img
            src="../assets/images/pakiet-pszczelego-bohatera.jpeg"
            class="about__img mb-3"
            alt="Pakiet Pszczelego Bohatera"
          />
          Jeśli zdecydujesz się adoptować regularnie przynajmniej 10 pszczół i
          comiesięcznie wspierać ochronę zapylaczy, otrzymasz od nas
          Pakiet Pszczelego Bohatera / Bohaterki! <br /> <br /> Na Pakiet składają się:
          <br /> <br />
          <ol>
            <li>
              Stylowa, kwiecista maseczka, wykonana z ekologicznej tkaniny przez lokalną, rodzinną firmę.
            </li>
            <li>
              Certyfikat Pszczelego Bohatera / Bohaterki - otrzymasz specjalny
              imienny certyfikat potwierdzający, że jesteś Pszczelą Bohaterką /
              Pszczelim Bohaterem!
            </li>
            <li>
              Świetna książka autorstwa Dave'a Goulsona pt. Łąka o fascynującym świecie najmniejszych mieszkańców łąk. Czy owadom chodzi tylko o jedzenie i seks? Dlaczego motyle są w plamki? Po co stuka tykotek? Czemu miłość pluskwiaka tak rani? Czy słusznie brzydzimy się much? Jak szybka może być ważka? I czy polityka os jest lepsza niż ludzka? Tego wszystkiego dowiesz się z "Łąki"!


            </li>
          </ol>
        </div>
         <router-link class="about__btn" to="/pytania-i-odpowiedzi/pakiet-pszczelego-bohatera">
            Dowiedz się więcej
            <font-awesome-icon :icon="['fas', 'angle-double-right']" />
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BeeHeroPack",
  data() {
    return {
      title: "PPB",
    };
  },
};
</script>
